/*
"ItemCategoryStatus":{
   "required":[
      "code",
      "name",
      "scannedCount",
      "totalCount"
   ],
   "type":"object",
   "properties":{
      "code":{
         "description":"Schnittstellen-Code der Gegenstandskategorie",
         "type":"string"
      },
      "name":{
         "description":"Name der Gegenstandskateogrie",
         "type":"string"
      },
      "scannedCount":{
         "format":"int32",
         "description":"Anzahl bereits gescannter Gegenstände",
         "type":"integer"
      },
      "totalCount":{
         "format":"int32",
         "description":"Gesamtanzahl aller zu scannenden Gegenstände",
         "type":"integer"
      }
   }
}
*/
import { ItemCategory } from './item-category';

export class ItemCategoryStatus {
  constructor(
    public code: string,
    public name: string,
    public scannedCount: number,
    public totalCount: number
  ) { }

  public static fromJSON(json: {
    code: string,
    name: string,
    scannedCount: number,
    totalCount: number,
  }): ItemCategoryStatus {
    if (!json) {
      throw new Error('ItemCategoryStatus JSON should not be undefined');
    }
    if (!json.code) {
      throw new Error('ItemCategoryStatus JSON should have property: code');
    }
    if (!json.name) {
      throw new Error('ItemCategoryStatus JSON should have property: name');
    }
    if (!json.scannedCount === undefined || json.scannedCount === null) {
      throw new Error('ItemCategoryStatus JSON should have property: scannedCount');
    }
    if (json.totalCount === undefined || json.totalCount === null) {
      throw new Error('ItemCategoryStatus JSON should have property: totalCount');
    }

    return new ItemCategoryStatus(
      json.code,
      json.name,
      json.scannedCount,
      json.totalCount
    );
  }

  public get isComplete(): boolean {
    return this.scannedCount === this.totalCount && this.totalCount >= 0;
  }

  get iconName(): string {
    return ItemCategory.getIconName(this.code);
  }
}
